import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import {
  BellIcon,
  ShieldCheckIcon,
  QuestionMarkCircleIcon,
  ArrowRightOnRectangleIcon,
  SunIcon,
  MoonIcon
} from '@heroicons/react/24/outline';

function Settings() {
  const { logout } = useAuth();
  const { isDarkMode, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  const settingsItems = [
    {
      icon: BellIcon,
      title: 'Notifications',
      description: 'Configure notification preferences',
      path: '/notifications',
      action: () => navigate('/notifications')
    },
    {
      icon: ShieldCheckIcon,
      title: 'Privacy & Security',
      description: 'Manage your privacy settings',
      path: '/privacy',
      action: () => navigate('/privacy')
    },
    {
      icon: QuestionMarkCircleIcon,
      title: 'Help & Support',
      description: 'Get help with the app',
      path: '/help',
      action: () => navigate('/help')
    }
  ];

  return (
    <div className="min-h-screen bg-[#f56756] text-white p-6">
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold text-[#402e2c]">Settings</h1>
        </div>

        <div className="space-y-4">
          {/* Dark Mode Toggle */}
          <button
            onClick={toggleTheme}
            className="w-full flex items-center justify-between p-4 bg-[#b34e42] rounded-xl hover:bg-[#000055] transition-colors"
          >
            <div className="flex items-center space-x-4">
              <div className="p-2 bg-[#402e2c]/20 rounded-lg">
                {isDarkMode ? (
                  <SunIcon className="h-5 w-5 text-[#402e2c]" />
                ) : (
                  <MoonIcon className="h-5 w-5 text-[#402e2c]" />
                )}
              </div>
              <div className="text-left">
                <h3 className="font-medium text-white">
                  {isDarkMode ? 'Light Mode' : 'Dark Mode'}
                </h3>
                <p className="text-sm text-gray-400">
                  Switch between light and dark theme
                </p>
              </div>
            </div>
            {isDarkMode ? (
              <SunIcon className="h-5 w-5 text-gray-400" />
            ) : (
              <MoonIcon className="h-5 w-5 text-gray-400" />
            )}
          </button>

          {/* Other Settings */}
          {settingsItems.map((item) => (
            <button
              key={item.title}
              onClick={item.action}
              className="w-full flex items-center justify-between p-4 bg-[#b34e42] rounded-xl hover:bg-[#000055] transition-colors"
            >
              <div className="flex items-center space-x-4">
                <div className="p-2 bg-[#402e2c]/20 rounded-lg">
                  <item.icon className="h-5 w-5 text-[#402e2c]" />
                </div>
                <div className="text-left">
                  <h3 className="font-medium text-white">
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-400">
                    {item.description}
                  </p>
                </div>
              </div>
              <item.icon className="h-5 w-5 text-gray-400" />
            </button>
          ))}
        </div>

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="w-full flex items-center justify-center space-x-2 p-4 bg-[#614a48] text-white rounded-xl font-medium hover:bg-[#614a48]/90 transition-colors mt-8"
        >
          <ArrowRightOnRectangleIcon className="h-5 w-5" />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
}

export default Settings; 